
const BLOBS = [
  // Vector 1 — large wash covering the full left side
  { left: "0%", top: "0%", width: "89%", height: "100%", color: "#5881E9", opacity: 0.5 },
  // Vector 2 — light highlight, upper right
  { left: "51%", top: "2.5%", width: "49%", height: "46%", color: '#5881E9A6', opacity: 0.5 },
  // Vector 3 — softer blue blend zone, center/lower
  { left: "28%", top: "42%", width: "46%", height: "37%", color: "#ABC5FF", opacity: 1 },
  // Vector 4 — pink accent, lower right
  { left: "46%", top: "34%", width: "47%", height: "46%", color: "#F1C5DC", opacity: 0.6   },
];

export default function BackgroundBlobs({ className = "" }) {
  return (
    <div className={`absolute inset-0 overflow-hidden ${className}`} aria-hidden="true">
      <div className="absolute inset-0 bg-[#f6f6f667]" />
      <div className="absolute inset-0 blur-[70px]">
        {BLOBS.map((blob, i) => (
          <div
            key={i}
            className="absolute rounded-full"
            style={{
              left: blob.left,
              top: blob.top,
              width: blob.width,
              height: blob.height,
              backgroundColor: blob.color,
              opacity: blob.opacity,
            }}
          />
        ))}
      </div>
    </div>
  );
}

/* Usage — drop-in replacement for the light-mode <img> in getBgPair():

<BackgroundBlobs className="dark:hidden" />
<img src={darkBgSrc} className={`${BG_CLASS} hidden dark:block`} />

*/